import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfigProd = {
  apiKey: "AIzaSyBjRfrWoM1W_aAOQzLQBzISep1h4gDjD6g",
  authDomain: "ajjas-173113.firebaseapp.com",
  databaseURL: "https://ajjas-173113.firebaseio.com",
  projectId: "ajjas-173113",
  storageBucket: "ajjas-173113.appspot.com",
  messagingSenderId: "779180948090",
  appId: "1:779180948090:web:0ba6c713a2212b315399c3",
  measurementId: "G-NNC8T6RS74",
};

const firebaseConfigDev = {
  apiKey: "AIzaSyAu8_48HMK-mkYRIIN-aadjqKlg-f1fRlg",
  authDomain: "ajjas-1cc56.firebaseapp.com",
  databaseURL: "https://ajjas-1cc56.firebaseio.com",
  projectId: "ajjas-1cc56",
  storageBucket: "ajjas-1cc56.appspot.com",
  messagingSenderId: "570239730859",
  appId: "1:570239730859:web:0f7affa9ac54fe332ca3ee",
  measurementId: "G-CHH29L037V",
};

const isProduction = window.location.hostname === "web.ajjas.com";
const appConfig = isProduction ? firebaseConfigProd : firebaseConfigDev;

const app = initializeApp(appConfig);
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.warn("Analytics not available:", error);
}

export { analytics };